import { useEffect } from "react";
import { useWatch } from "react-hook-form";
import { Form } from "../../shared/uikit/Form";
import { CONVERSATION_STATUSES, CONVERSATION_TYPES } from "../constants";
import type { ConversationChannelFilterOptions } from "../types/ConversationChannelFilterOptions";
import type { ConversationStatusFilterOptions } from "../types/ConversationStatusFilterOptions";
import { FormItem } from "./forms/FormItem";

interface Filters {
  status: ConversationStatusFilterOptions;
  type: ConversationChannelFilterOptions;
}

export const ConversationFilters = ({
  onFiltersChange,
}: {
  onFiltersChange: (filters: Filters) => void;
}) => {
  const [type, status] = useWatch<Filters, ["type", "status"]>({
    name: ["type", "status"],
  });

  useEffect(() => {
    onFiltersChange({ type, status });
  }, [type, status, onFiltersChange]);

  return (
    <div className="w-full px-4">
      <div className="flex gap-2">
        <div className="w-1/2">
          <FormItem
            name="type"
            hideLabel
            translationRoot="help_widget.conversation_list_page"
          >
            <Form.Select name="type" data={CONVERSATION_TYPES} />
          </FormItem>
        </div>
        <div className="w-1/2">
          <FormItem
            name="status"
            hideLabel
            translationRoot="help_widget.conversation_list_page"
          >
            <Form.Select name="status" data={CONVERSATION_STATUSES} />
          </FormItem>
        </div>
      </div>
    </div>
  );
};
